export enum FlagResolution {
  AnyStatus = 'Any status',
  NotResolved = 'Not resolved',
  FlagRaised = 'Flag raised',
  Resolved = 'Resolved',
}
